/*
* @description
* Smart Assistant is displayed on the nav bar, and is used to search patients and navigate through TrakCare.
*
*/
angular.module('tcApp')
.controller('AssistantCtrl', function($scope, GlobalService, OverlayService) {
    var onInit = function() {
        $scope.globalStrings = GlobalService.getGlobalStrings();

        $scope.viewModel = { 
			currentPatientInContext: '',
			currentEpisodeInContext: '',
			searchOpen: false,
			EnableParam: false
			};
        
       
    };

	$scope.openSearch = function() {
		if ($scope.viewModel.searchOpen) {
			return;
		}
		$scope.viewModel.searchOpen = true;
		
		var overlayOptions = {
			componentName: 'websys.Assistant.Composite',
			params: '&PatientInContext=' + $scope.viewModel.currentPatientInContext
				+ '&EpisodeInContext=' + $scope.viewModel.currentEpisodeInContext,
			onRemovingHandler: $scope.closeSearch,
			displayTop: true
		};
		OverlayService.open(overlayOptions);
	};

	$scope.closeSearch = function() {
		$scope.viewModel.searchOpen = false;
	};
    
	// Update current Patient and Episode in context
	var updateCurrentPatientEpisodeInContext = function(bannerData) {
		if (!bannerData) {
			bannerData = {};
		}
		var patientInContext = '';
		var episodeInContext = '';
		if (angular.isDefined(bannerData.items)) {
			if (angular.isDefined(bannerData.items.BANNERPatientID)) {
				patientInContext = bannerData.items.BANNERPatientID.value;
			} 
			if (angular.isDefined(bannerData.items.BANNEREpisodeID)) {
				episodeInContext = bannerData.items.BANNEREpisodeID.value;
			}
		}
		$scope.viewModel.currentPatientInContext = patientInContext;
		$scope.viewModel.currentEpisodeInContext = episodeInContext;
	};
	
	// Catch Global:updated event broadcasted by GlobalService
	var catchUpdateBanner = function(event, bannerData) {
		
		// Update current Patient and Episode in context
		updateCurrentPatientEpisodeInContext(bannerData);
			
		$scope.viewModel.EnableParam = EnableOrDisable($scope.viewModel.currentPatientInContext);
	};
    
    var EnableOrDisable = function(patientInContext,sessionData) {
		//retrieve value of system parameter.
		var displayAssistantParam = '';
		if (angular.isUndefined(sessionData)) {
			displayAssistantParam = GlobalService.logonData.userDisplayAssistant;
		} else {
			displayAssistantParam = sessionData.logonData.userDisplayAssistant;
		}
		
		if ((displayAssistantParam == 'PO')&&(patientInContext == '')) {
			return false;
		}
		if (displayAssistantParam == '') {
			return false;
		}
		
		return true;
	};

	$scope.$on('Global:updateBanner', catchUpdateBanner);
    
    onInit();
});
